import ApplicationLayout from "../layouts/ApplicationLayout";
import GuestLayout from "../layouts/GuestLayout";
import AuthMiddleware from '../middlewares/auth.middleware';
import GuestMiddleware from '../middlewares/guest.middleware';
import AdminMiddleware from '../middlewares/admin.middleware';
import Dashboard from "../components/application/views/Dashboard";
import HttpNotFound from "../layouts/HttpNotFound";
import Search from "../components/application/views/Search";
import NewsDetails from "@/components/application/views/NewsDetails";
import News from "@/components/application/views/News";
import NewsCategory from "@/components/application/views/NewsCategory";
import Media from "@/components/application/views/Media";

/*
   Administration
 */
const Administration = () => import('../components/administration/views/Administration.vue');
const Overview = () => import('../components/administration/Overview.vue');
const CategoryOverview = () => import('../components/administration/category/CategoryOverview.vue');
const NewsCategoryManager = () => import("../components/administration/category/NewsCategoryManager");
const FailedOrderOverview = () => import("@/components/administration/orders/FailedOrderOverview");
const FailedOrder = () => import("@/components/administration/orders/FailedOrder");
const NewsOverview = () => import("@/components/administration/news/NewsOverview");
const NewsEditor = () => import("@/components/administration/news/NewsEditor");

/*
    ProductCategory
 */
const ProductCategory = () => import("../components/application/views/ProductCategory");
const ProductDetails = () => import("../components/application/views/ProductDetails");

/*
    Cart
 */
const CartView = () => import("../components/application/views/Cart");
const CheckoutView = () => import("../components/application/views/Checkout");

/*
    Configurator
 */
const Configurator = () => import("../components/application/views/Configurator");

/*
    Stocklist
 */
const StocklistFifo = () => import("../components/application/views/StocklistFifo");
const StocklistDetails = () => import("../components/application/views/StocklistDetails");
/*
    Stocklist in Transit
 */
const StocklistTransit = () => import("../components/application/views/StocklistTransit");

/*
    ShopOrd
 */
const ShopOrd = () => import("../components/application/views/ShopOrd");
const ShopOrdDetails = () => import("../components/application/views/ShopOrdDetails");

/*
    Stock Mixed
 */
const StockMixed = () => import("../components/application/views/StockMixed");

const routes = [
    {
        path: '/',
        name: 'app.guest',
        beforeEnter: GuestMiddleware,
        component: GuestLayout
    },
    {
        path: '/realms',
        name: 'app.realm',
        beforeEnter: AuthMiddleware,
        component: GuestLayout
    },
    {
        path: '/app',
        beforeEnter: AuthMiddleware,
        component: ApplicationLayout,
        children: [
            {
                path: '',
                name: 'app.start',
                component: Dashboard
            },
            {
                path: 'products/:category(.*)?/view/:catalogNo(.*)',
                name: 'app.product.concrete',
                component: ProductDetails,
            },
            {
                path: 'products/:category(.*)',
                name: 'app.product.category',
                component: ProductCategory,
            },
            {
                path: 'cart',
                name: 'app.cart',
                component: CartView
            },
            {
                path: 'checkout',
                name: 'app.checkout',
                component: CheckoutView
            },
            {
                path: 'configurator/:productIdentifier',
                name: 'app.configurator',
                component: Configurator
            },
            {
              path: 'stocklist',
              name: 'app.stocklist',
              component: StocklistFifo,
            },
            {
                path: 'stocklist/view/:catalogNo/:configNo/:warehouse',
                name: 'app.stocklist.view',
                component: StocklistDetails,
            },
            {
                path: 'stocklist-transit',
                name: 'app.stocklist.transit',
                component: StocklistTransit,
            },
            {
                path: 'stocklist-transit/view/:uniqueId',
                name: 'app.stocklist.transit.view',
                component: StocklistDetails,
            },
            {
                path: 'under-production',
                name: 'app.shopord',
                component: ShopOrd,
            },
            {
                path: 'under-production/view/:uniqueId',
                name: 'app.shopord.view',
                component: ShopOrdDetails,
            },
            {
                path: 'stock',
                name: 'app.stock-mixed',
                component: StockMixed,
            },
            {
                path: 'search',
                name: 'app.search',
                component: Search,
            },
            {
                path: 'news',
                name: 'app.news',
                component: News,
            },
            {
                path: 'news/:slug',
                name: 'app.news.category',
                component: NewsCategory,
            },
            {
                path: 'news/post/:slug',
                name: 'app.news.view',
                component: NewsDetails,
            },
            {
                path: 'media',
                name: 'app.media',
                component: Media,
            },
            {
                path: 'administration',
                component: Administration,
                beforeEnter: AdminMiddleware,
                children: [
                    {
                        path: '',
                        name: 'app.admin',
                        component: Overview
                    },
                    {
                        path: 'categories',
                        name: "app.admin.category",
                        component: CategoryOverview,
                        children: [
                            {
                                path: 'news',
                                name: 'app.admin.category.news',
                                component: NewsCategoryManager
                            }
                        ]
                    },
                    {
                        path: 'failed-orders',
                        name: 'app.admin.orders.failed',
                        component: FailedOrderOverview
                    },
                    {
                        path: 'failed-orders/:failedOrderId',
                        name: 'app.admin.orders.failed.concrete',
                        component: FailedOrder
                    },
                    {
                        path: 'news',
                        name: 'app.admin.news',
                        component: NewsOverview
                    },
                    {
                        path: 'news/create',
                        name: 'app.admin.news.create',
                        component: NewsEditor
                    },
                    {
                        path: 'news/:id',
                        name: 'app.admin.news.edit',
                        component: NewsEditor
                    },
                ],
            }
        ]
    },
    {
        path: '*',
        name: 'app.404',
        component: HttpNotFound
    }
];

export default routes;
